(() => {
  const pathIsHush = /^\/products\/hush-gummies(?:\/|$)/.test(window.location.pathname);

  if (!pathIsHush || window.HermeticaHushCroEnabled !== true || window.HermeticaHushPdpCro20260710) return;
  window.HermeticaHushPdpCro20260710 = true;

  let productPromise;
  let refreshTimer;
  let requestedModeApplied = false;
  const requestedPurchase = new URLSearchParams(window.location.search).get('purchase');

  const money = (cents) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format((Number(cents) || 0) / 100);

  const getProduct = () => {
    if (!productPromise) {
      productPromise = fetch('/products/hush-gummies.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Hush product data unavailable');
          return response.json();
        })
        .catch(() => null);
    }
    return productPromise;
  };

  const selectedPack = () =>
    document.querySelector('.mrk-bundle-wrap--hush .mrk-bundle__card-radio:checked[data-variant-id]');

  const selectedPurchaseMode = () => {
    const checked = document.querySelector('.mrk-bundle-wrap--hush .mrk-bundle__sub-radio:checked');
    return {
      subscribe: checked?.dataset.isSubscription === 'true',
      planId: checked?.dataset.sellingPlanId || '',
    };
  };

  const applyRequestedPurchaseMode = () => {
    if (requestedModeApplied || !requestedPurchase) return;
    const selector =
      requestedPurchase === 'subscription'
        ? '.mrk-bundle-wrap--hush .mrk-bundle__sub-radio[data-is-subscription="true"]'
        : '.mrk-bundle-wrap--hush .mrk-bundle__sub-radio[data-is-subscription="false"]';
    const radio = document.querySelector(selector);
    if (!radio) return;
    requestedModeApplied = true;
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const mainPurchaseForms = () => {
    const wrap = document.querySelector('.mrk-bundle-wrap--hush');
    const scope = wrap?.closest('.shopify-section') || document.querySelector('#MainContent');
    if (!scope) return [];
    return Array.from(scope.querySelectorAll('form[action*="/cart/add"]')).filter(
      (form) => !form.closest('.hsf-mobile-buybar, .hsf-pdp-quick-commit, sticky-add-to-cart')
    );
  };

  const syncMainVariant = (variantId) => {
    let changed = false;
    mainPurchaseForms().forEach((form) => {
      const input = form.querySelector('input[name="id"], select[name="id"]');
      if (!input || String(input.value) === String(variantId)) return;
      input.value = String(variantId);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      changed = true;
    });
    return changed;
  };

  const setText = (node, value) => {
    if (node && node.textContent !== value) node.textContent = value;
  };

  const allocationFor = (variant, planId) =>
    variant?.selling_plan_allocations?.find(
      (allocation) => String(allocation.selling_plan_id) === String(planId)
    );

  const syncForm = (surface, form, variant, mode) => {
    if (!surface || !form || !variant) return;

    surface.querySelectorAll('.hsf-plan-choice').forEach((choice) => choice.remove());
    surface.classList.remove('is-plan-enhanced');
    surface.dataset.hsfSelectedPlanMode = mode.subscribe ? 'subscribe' : 'one-time';

    let variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) {
      variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'id';
      form.prepend(variantInput);
    }
    variantInput.value = String(variant.id);

    let quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      form.appendChild(quantityInput);
    }
    quantityInput.value = '1';

    form.querySelectorAll('input[name="selling_plan"]').forEach((input) => {
      if (!input.hasAttribute('data-hsf-hush-cro-plan')) input.remove();
    });

    let planInput = form.querySelector('input[data-hsf-hush-cro-plan]');
    if (mode.subscribe && mode.planId) {
      if (!planInput) {
        planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.setAttribute('data-hsf-hush-cro-plan', 'true');
        form.appendChild(planInput);
      }
      planInput.name = 'selling_plan';
      planInput.value = mode.planId;
      planInput.disabled = false;
    } else if (planInput) {
      planInput.remove();
    }

    const allocation = mode.subscribe ? allocationFor(variant, mode.planId) : null;
    const displayPrice = allocation?.per_delivery_price || allocation?.price || variant.price;
    const cadence = mode.subscribe ? 'Monthly' : 'One-time';
    const priceText = mode.subscribe ? `${money(displayPrice)}/delivery` : money(displayPrice);
    const buttonText = `${mode.subscribe ? 'Subscribe' : 'Add'} ${variant.title}`;

    if (surface.matches('.hsf-mobile-buybar')) {
      setText(surface.querySelector('.hsf-mobile-buybar__copy strong'), `${variant.title} · ${cadence}`);
      setText(surface.querySelector('.hsf-mobile-buybar__copy span'), priceText);
      setText(surface.querySelector('.hsf-mobile-buybar__button'), buttonText);
      surface.querySelector('.hsf-mobile-buybar__copy span')?.setAttribute('aria-live', 'polite');
    } else {
      setText(surface.querySelector('.hsf-pdp-quick-commit__copy strong'), priceText);
      setText(surface.querySelector('.hsf-pdp-quick-commit__copy small'), `${variant.title} · ${cadence}`);
      setText(surface.querySelector('.hsf-pdp-quick-commit__button'), buttonText);
    }
  };

  const refresh = async () => {
    const product = await getProduct();
    if (!product) return;

    applyRequestedPurchaseMode();
    const pack = selectedPack();
    const fallbackId = mainPurchaseForms()[0]?.querySelector('input[name="id"], select[name="id"]')?.value;
    const variantId = pack?.dataset.variantId || fallbackId || product.variants?.[0]?.id;
    const variant = product.variants?.find((item) => String(item.id) === String(variantId));
    if (!variant) return;

    if (pack && syncMainVariant(variant.id)) {
      pack.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const mode = selectedPurchaseMode();
    document.querySelectorAll('.hsf-mobile-buybar, .hsf-pdp-quick-commit').forEach((surface) => {
      syncForm(surface, surface.querySelector('form[action*="/cart/add"]'), variant, mode);
    });
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 40);
  };

  document.addEventListener(
    'change',
    (event) => {
      if (!event.target.matches('.mrk-bundle__card-radio, .mrk-bundle__sub-radio')) return;
      scheduleRefresh();
      window.setTimeout(refresh, 140);
    },
    true
  );
  document.addEventListener('variant:update', scheduleRefresh);
  document.addEventListener('product:variant-change', scheduleRefresh);

  const start = () => {
    refresh();
    window.setTimeout(refresh, 500);
    window.setTimeout(refresh, 1500);
    window.setTimeout(refresh, 3200);

    const observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
